import { useContent } from '@sitecore/common';
import { ConsumptionGraphicalOverviewRendering } from '@sitecore/types/ConsumptionGraphicalOverview';
import { StringParam, useQueryParam } from 'use-query-params';

import DataErrorNotification from '../../../../components/DataErrorNotification';
import { useAddressOptions } from '../../../../hooks/useAddressOptions';
import { useAdvances } from '../../advance/hooks/useAdvances';
import TotalAdvancesCard from '../../advance/TotalAdvancesCard';
import { getAdvancesByConsumptionType } from '../utils/filterAdvancesByConsumptionType';

const TotalAdvancesCardWrapper = () => {
  const { fields } = useContent<ConsumptionGraphicalOverviewRendering>();
  const { addressIdentifier } = useAddressOptions();
  const [consumptionType] = useQueryParam('consumptionType', StringParam);

  const {
    activeAdvances,
    isInMeterReadingMonth,
    isDefaulter,
    reconcileAdvanceAmount,
    hideEdit,
    submitGlobalRecommendedAdvance,
    error,
    isLoading,
  } = useAdvances(addressIdentifier, {
    title: fields.advanceCard?.recommendedAmountNotification?.value.title,
    text: fields.advanceCard?.recommendedAmountNotification?.value.content,
    variant: fields.advanceCard?.recommendedAmountNotification?.value.variant,
    isAlert: true,
  });

  if (error) {
    return <DataErrorNotification />;
  }

  const advancesByConsumptionType = getAdvancesByConsumptionType(activeAdvances, consumptionType);
  const hasOnlyMonthlyInvoiceFrequency = advancesByConsumptionType?.every(
    advance => advance.meterDetails?.invoiceFrequency === 'Monthly',
  );
  const hasAnalogueMeter = advancesByConsumptionType?.some(advance => advance.meterDetails?.meterType === 'Analogue');

  if (hasOnlyMonthlyInvoiceFrequency || isLoading) {
    return null;
  }
  return (
    <TotalAdvancesCard
      fields={fields}
      recommendedAmount={activeAdvances?.totals?.recommendedAmount}
      currentAmount={activeAdvances?.totals?.currentAmount}
      reconcileAdvanceAmount={reconcileAdvanceAmount}
      hideRecommendedAmount={(isInMeterReadingMonth || isDefaulter) ?? true}
      hideEdit={hideEdit}
      addressIdentifier={addressIdentifier}
      globalRecommendedAdvancesOnChange={amount => submitGlobalRecommendedAdvance({ amount })}
      isEnergyMonitorView={true}
      hasAnalogueMeter={hasAnalogueMeter}
    />
  );
};

export default TotalAdvancesCardWrapper;
